"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawableAcceptBinding = drawableAcceptBinding;
function drawableAcceptBinding(dc, evt) {
    const drawableId = dc.state.selectedId;
    if (drawableId == null) {
        return;
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
    const drawable = dc.selected;
    if (drawable == null) {
        return;
    }
    if (!drawable.isApprovableInsightDrawable()) {
        return;
    }
    drawable.approveInsightFlag();
}
//# sourceMappingURL=drawable.accept.binding.js.map